import { lazy } from 'react';

export { TenderNew } from './tender-new';

export const LazyTenderNew = lazy(() => import('./tender-new').then((mod) => ({ default: mod.TenderNew })));
